/**
 * Campaign Onboarding - Run-all orchestrator and status polling
 */
(function (global) {
  "use strict";

  var CampaignOnboarding = global.CampaignOnboarding;

  function showViewCampaignsButton() {
    var container = document.getElementById("view-campaigns-container");
    if (container) {
      container.style.display = "block";
    } else {
      var runAllContainer = document.querySelector(".run-all-container");
      if (runAllContainer) {
        var btnContainer = document.createElement("div");
        btnContainer.id = "view-campaigns-container";
        btnContainer.style.marginTop = "20px";
        btnContainer.innerHTML =
          '<a href="/" class="btn btn-success btn-lg"><i class="glyphicon glyphicon-list"></i> View All Campaigns</a>';
        runAllContainer.appendChild(btnContainer);
      }
    }
  }

  function pollRunAllStatus(urls, runAllBtn, runAllStatus, currentStepEl) {
    var attempts = 0;
    var statusDetailsEl = document.getElementById("run-all-status-details");
    var statusContentEl = document.getElementById("run-all-status-content");
    var stepNames = CampaignOnboarding.STEP_NAMES;
    var maxAttempts = CampaignOnboarding.MAX_POLL_ATTEMPTS;
    var pollInterval = CampaignOnboarding.POLL_INTERVAL;

    if (statusDetailsEl) statusDetailsEl.style.display = "block";

    var operationsProgressContainer = document.getElementById(
      "run-all-operations-progress-container",
    );
    var operationsProgressList = document.getElementById(
      "run-all-operations-progress",
    );

    function updateStatusDisplay(status) {
      if (!statusContentEl) return;

      if (operationsProgressContainer && operationsProgressList) {
        if (
          status.run_all_operations_progress &&
          status.run_all_operations_progress.length > 0
        ) {
          operationsProgressContainer.style.display = "block";
          operationsProgressList.innerHTML = "";
          status.run_all_operations_progress.forEach(function (op) {
            var li = document.createElement("li");
            var opLabel = "Op " + op.index + "/" + op.total;
            var shortId =
              op.operation_id.length > 12
                ? op.operation_id.slice(0, 8) + "\u2026"
                : op.operation_id;
            var stepText = op.step_label || op.step || "";
            var strong = document.createElement("strong");
            strong.textContent = opLabel;
            li.appendChild(strong);
            li.appendChild(document.createTextNode(" " + shortId + " "));
            if (op.completed) {
              var doneSpan = document.createElement("span");
              doneSpan.className = "text-success";
              doneSpan.textContent = "\u2713 done";
              li.appendChild(doneSpan);
            } else {
              li.appendChild(document.createTextNode("\u2014 " + stepText));
            }
            operationsProgressList.appendChild(li);
          });
        } else {
          operationsProgressContainer.style.display = "none";
          operationsProgressList.innerHTML = "";
        }
      }

      var fragment = document.createDocumentFragment();

      if (
        !(
          status.run_all_operations_progress &&
          status.run_all_operations_progress.length > 0
        ) &&
        status.current_operation_index &&
        status.total_operations
      ) {
        var opLine = document.createElement("div");
        var opStrong = document.createElement("strong");
        opStrong.textContent = "Operation Progress: ";
        opLine.appendChild(opStrong);
        opLine.appendChild(
          document.createTextNode(
            status.current_operation_index + "/" + status.total_operations,
          ),
        );
        fragment.appendChild(opLine);
      }

      var statusRespStrong = document.createElement("strong");
      statusRespStrong.textContent = "Status Response:";
      var statusRespLine = document.createElement("div");
      statusRespLine.appendChild(statusRespStrong);
      fragment.appendChild(statusRespLine);

      var flags = [
        "bearer_token_valid",
        "operation_id_present",
        "campaign_details_present",
        "sync_started",
        "payload_ready",
        "campaign_created",
        "accounts_imported",
        "transactions_imported",
        "completed",
        "run_all_in_progress",
        "run_all_completed",
      ];

      flags.forEach(function (flag) {
        if (status[flag] !== undefined) {
          var icon = status[flag] ? "\u2713" : "\u00B7";
          var cls = status[flag] ? "text-success" : "text-muted";
          var span = document.createElement("span");
          span.className = cls;
          span.textContent = icon + " " + flag;
          var flagLine = document.createElement("div");
          flagLine.appendChild(span);
          fragment.appendChild(flagLine);
        }
      });

      if (status.current_run_all_step) {
        var stepName =
          stepNames[status.current_run_all_step] || status.current_run_all_step;
        if (status.current_operation_index) {
          stepName += " (Op " + status.current_operation_index + ")";
        }
        var stepLine = document.createElement("div");
        var stepStrong = document.createElement("strong");
        stepStrong.textContent = "Current step: ";
        stepLine.appendChild(stepStrong);
        stepLine.appendChild(document.createTextNode(stepName));
        fragment.appendChild(stepLine);
      }

      if (status.campaign_id) {
        var campLine = document.createElement("div");
        var campStrong = document.createElement("strong");
        campStrong.textContent = "Campaign ID: ";
        campLine.appendChild(campStrong);
        campLine.appendChild(
          document.createTextNode(String(status.campaign_id)),
        );
        fragment.appendChild(campLine);
      }

      if (status.latest_error) {
        var errLine = document.createElement("div");
        var errSpan = document.createElement("span");
        errSpan.className = "text-danger";
        var errStrong = document.createElement("strong");
        errStrong.textContent = "Error: ";
        errSpan.appendChild(errStrong);
        errSpan.appendChild(document.createTextNode(status.latest_error));
        errLine.appendChild(errSpan);
        fragment.appendChild(errLine);
      }

      statusContentEl.innerHTML = "";
      statusContentEl.appendChild(fragment);

      if (statusDetailsEl)
        statusDetailsEl.scrollTop = statusDetailsEl.scrollHeight;
    }

    function checkStatus() {
      attempts++;
      if (attempts > maxAttempts) {
        if (runAllBtn) {
          runAllBtn.disabled = false;
          runAllBtn.innerHTML =
            '<i class="glyphicon glyphicon-play"></i> Start DonorStack Onboarding';
        }
        if (runAllStatus) {
          runAllStatus.innerHTML =
            '<i class="glyphicon glyphicon-remove text-danger"></i> <span class="text-danger">Timed out</span>';
        }
        return;
      }

      fetch(urls["status"], {
        method: "GET",
        headers: { Accept: "application/json" },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (status) {
          updateStatusDisplay(status);

          if (status.waiting_for_operation_id) {
            if (currentStepEl) currentStepEl.textContent = "Starting...";
            setTimeout(checkStatus, pollInterval);
            return;
          }

          if (status.current_run_all_step && currentStepEl) {
            currentStepEl.textContent =
              stepNames[status.current_run_all_step] ||
              status.current_run_all_step;
          }

          if (status.run_all_completed || status.completed) {
            if (runAllBtn) {
              runAllBtn.disabled = true;
              runAllBtn.innerHTML = status.completed
                ? '<i class="glyphicon glyphicon-ok"></i> Onboarding Complete!'
                : '<i class="glyphicon glyphicon-ok"></i> Run All Completed';
              runAllBtn.classList.remove("btn-primary");
              runAllBtn.classList.add("btn-success");
            }
            if (runAllStatus) {
              runAllStatus.innerHTML =
                '<i class="glyphicon glyphicon-ok text-success"></i> <span class="text-success">' +
                (status.completed
                  ? "Onboarding complete!"
                  : "Run all completed. View campaigns to approve merges.") +
                "</span>";
            }
            showViewCampaignsButton();
            return;
          }

          if (status.run_all_failed) {
            if (runAllBtn) {
              runAllBtn.disabled = false;
              runAllBtn.innerHTML =
                '<i class="glyphicon glyphicon-play"></i> Start DonorStack Onboarding';
            }
            if (runAllStatus) {
              runAllStatus.innerHTML = "";
              var failIcon = document.createElement("i");
              failIcon.className = "glyphicon glyphicon-remove text-danger";
              runAllStatus.appendChild(failIcon);
              runAllStatus.appendChild(document.createTextNode(" "));
              var failSpan = document.createElement("span");
              failSpan.className = "text-danger";
              failSpan.textContent =
                "Failed: " + (status.latest_error || "Unknown error");
              runAllStatus.appendChild(failSpan);
            }
            return;
          }

          if (runAllBtn) {
            runAllBtn.innerHTML =
              '<i class="glyphicon glyphicon-refresh spinning"></i> Running...';
          }

          setTimeout(checkStatus, pollInterval);
        })
        .catch(function (error) {
          console.error("Error polling status:", error);
          setTimeout(checkStatus, pollInterval);
        });
    }

    checkStatus();
  }

  function runAllSteps(urls) {
    var runAllBtn = document.getElementById("run-all-steps-btn");
    var runAllStatus = document.getElementById("run-all-status");
    var currentStepEl = document.getElementById("run-all-current-step");

    if (runAllBtn) {
      runAllBtn.disabled = true;
      runAllBtn.innerHTML =
        '<i class="glyphicon glyphicon-refresh spinning"></i> Starting...';
      runAllBtn.dataset.originalText =
        '<i class="glyphicon glyphicon-play"></i> Start DonorStack Onboarding';
    }
    if (runAllStatus) runAllStatus.style.display = "inline";

    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    fetch(urls["run-all"], {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken ? csrfToken.getAttribute("content") : "",
      },
      body: JSON.stringify({}),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data.success) {
          throw new Error(data.error || "Failed to start");
        }
        pollRunAllStatus(urls, runAllBtn, runAllStatus, currentStepEl);
      })
      .catch(function (error) {
        if (runAllBtn) {
          runAllBtn.disabled = false;
          runAllBtn.innerHTML =
            '<i class="glyphicon glyphicon-play"></i> Start DonorStack Onboarding';
        }
        if (runAllStatus) {
          runAllStatus.innerHTML = "";
          var errIcon = document.createElement("i");
          errIcon.className = "glyphicon glyphicon-remove text-danger";
          runAllStatus.appendChild(errIcon);
          runAllStatus.appendChild(document.createTextNode(" "));
          var errSpan = document.createElement("span");
          errSpan.className = "text-danger";
          errSpan.textContent = "Error: " + error.message;
          runAllStatus.appendChild(errSpan);
        }
      });
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.showViewCampaignsButton = showViewCampaignsButton;
  global.CampaignOnboarding.runAllSteps = runAllSteps;
})(typeof window !== "undefined" ? window : this);
